import {Component, OnInit, Renderer2} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {AppService} from "@services/app.service";
import {Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {Subject, takeUntil, tap} from 'rxjs';
import {DatePipe} from '@angular/common';
import {ConfigService} from "@services/configService";
import {shopDetails} from "@pages/modal/shopdetails";
import {DistributorOrderDetails} from "@pages/modal/order/DistributorOrderDetails";
import {Order} from "@pages/modal/order/Order";

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
    destroy$: Subject<boolean> = new Subject<boolean>();
    searchText;
    paymentStatus: String[] = [];
    paymentStatusFilter: string | null = null;
    orderType: String[] = [];
    orderTypeFilter: string | null = null;
    date: String[] = [];
    dateFilter: string | null = null;
    uniqueDates: string[] = [];
    isLocalhost = window.location.hostname === 'localhost';
    shopList: shopDetails[] = [];
    retailerOrderDetails: DistributorOrderDetails[] = [];
    shopOrderDetails: Order[] = [];
    traderBasedPaymentOrder: Order[] = [];
    ShopPaymentsList: Order[] = [];


    constructor(
        private renderer: Renderer2,
        private toastr: ToastrService,
        private appService: AppService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private configService: ConfigService,
        private datePipe: DatePipe,
    ) {
    }
    ngOnInit() {
        this.getLoginBasedShopDetails();
        this.getAllOrderDetailsByDistributor();
    }

    getLoginBasedShopDetails() {
        this.spinner.show();
        this.appService.getShopDetails()
            .pipe(takeUntil(this.destroy$),
                tap(data => {
                    this.spinner.hide();
                })
            )
            .subscribe(
                (shopList) => {
                    console.log('Shop List::', shopList);
                    this.shopList = shopList;
                },
                (error: any) => {
                    console.log("error:", error.error?.message || "Something went wrong, please try again");
                    this.spinner.hide();
                },
                () => {
                    this.spinner.hide();
                }
            );
    }

    getAllOrderDetailsByDistributor() {
        this.spinner.show();
        this.appService
            .getOrderDetailsByDistributor()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                    this.spinner.hide();
                    console.log("Get Retailer Orders::", data);
                    this.retailerOrderDetails = data;
                    let orderDetail: Order[] = [];
                    for (let order of this.retailerOrderDetails) {
                        orderDetail = orderDetail.concat([...order.order]);
                    }
                    this.shopOrderDetails = orderDetail;
                    console.log(this.shopOrderDetails)
                }, (error: any) => {
                    console.log("error:", error.error?.message || "No Order Found");
                    this.spinner.hide();
                    this.toastr.error(error.error?.message || "No Order Found");
                },
                () => {
                    this.spinner.hide();
                })
    }

    shopBasedOrderDetails(event: any) {
        this.traderBasedPaymentOrder = [];
        const value = event.target.value;
        console.log(value);
        this.traderBasedPaymentOrder = this.shopOrderDetails.filter(id => id.traderId == value);
        this.paymentStatus = Array.from(new Set(this.traderBasedPaymentOrder.map(status => status.paymentStatus)));
        this.orderType = Array.from(new Set(this.traderBasedPaymentOrder.map(type => type.orderType)));
        const uniqueDates = Array.from(new Set(this.traderBasedPaymentOrder.map(item => item.orderDate)));
        const normalDate = uniqueDates.map(epoch =>
            this.datePipe.transform(epoch, 'dd/MM/yyyy')
        );
        this.uniqueDates = Array.from(new Set(normalDate));
        this.traderBasedPaymentOrder.sort((a, b) => b.orderId - a.orderId);
        this.ShopPaymentsList = this.traderBasedPaymentOrder;
    }

    getFormattedDate(createdAt: number): string {
        return this.datePipe.transform(createdAt, 'dd/MM/yyyy', 'IST', '');
    }

    isDuplicateDate(orderDate: number, index: number): boolean {
        // Check if the current date appears before (excluding) the current index
        return this.traderBasedPaymentOrder.slice(0, index).some(payment => payment.orderDate === orderDate);
    }


    paymentFilter(event: any, filterType: string) {
        const value = event.target.value;

        switch (filterType) {
            case 'status' :
                this.paymentStatusFilter = value !== 'Select Payment Status' ? value : null;
                break;
            case 'orderType' :
                this.orderTypeFilter = value !== 'Select Order Type' ? value : null;
                break;
            case 'date' :
                this.dateFilter = value !== 'Select Order Date' ? value : null;
                break;
            default:
                break;
        }
        this.applyPaymentFilter();
    }


    // Apply Payment above the types of filters
    applyPaymentFilter() {
        const paymentFilter = this.paymentStatusFilter ? this.traderBasedPaymentOrder.filter(status => status.paymentStatus === this.paymentStatusFilter) : this.traderBasedPaymentOrder;
        const typeFilter = this.orderTypeFilter ? paymentFilter.filter(type => type.orderType === this.orderTypeFilter) : paymentFilter;
        this.ShopPaymentsList = this.dateFilter
            ? typeFilter.filter(date => {
                const options: Intl.DateTimeFormatOptions = {day: '2-digit', month: '2-digit', year: 'numeric'};
                const formattedDate = new Date(date.orderDate).toLocaleDateString('en-GB', options);
                return formattedDate === this.dateFilter;
            })
            : typeFilter;
    }

    clearFilters() {
        this.paymentStatusFilter = 'Select Payment Status' && null;
        this.orderTypeFilter = 'Select Order Type' && null;
        this.dateFilter = 'Select Order Date' && null;
        this.applyPaymentFilter();
    }

    getOrderStatus(orderType: string): string {
        switch (orderType) {
            case 'CUSTOMER PICKUP':
                return 'Customer Pickup';

            case 'DOOR DELIVERY':
                return 'Door Delivery';

            default:
                return 'Unknown Order Type';
        }
    }
   /*


    //Get all Payment Details
    getAllPaymentDetails() {
        this.spinner.show();
        this.appService.getAllPayments()
            .pipe(takeUntil(this.destroy$),
                tap(data => {
                    this.spinner.hide();
                    this.paymentStatus = Array.from(new Set(data.map(status => status.paymentStatus)));
                    if (!environment.production && this.isLocalhost) {
                        console.log('Payment Status::', this.paymentStatus);
                    }
                    this.paymentType = Array.from(new Set(data.map(type => type.referenceType)));
                    const uniqueDates = Array.from(new Set(data.map(item => item.createdAt)));
                    const normalDate = uniqueDates.map(epoch =>
                        this.datePipe.transform(epoch, 'dd/MM/yyyy')
                    );
                    this.uniqueDates = Array.from(new Set(normalDate));
                    if (!environment.production && this.isLocalhost) {
                        console.log('unique Date', this.uniqueDates);
                    }
                })
            )
            .subscribe(
                (paymentList) => {
                    this.spinner.hide();
                    if (!environment.production && this.isLocalhost) {
                        console.log('payment list::', paymentList);
                    }
                    this.paymentDetailsList = paymentList;
                    this.paymentDetailsList.sort((a, b) => b.paymentId - a.paymentId);
                    this.paymentList = this.paymentDetailsList;
                },
                (error: any) => {
                    console.log("error:", error.error?.message || "Something went wrong, please try again");
                    this.spinner.hide();
                },
                () => {
                    this.spinner.hide();
                }
            );
    }


    /!*Payment Filter For sorting the table*!/
    paymentFilter(event: any, filterType: string) {
        const value = event.target.value;

        switch (filterType) {
            case 'status' :
                this.paymentStatusFilter = value !== 'Select Payment Status' ? value : null;
                break;
            case 'paymentType' :
                this.paymentTypeFilter = value !== 'Select Payment Type' ? value : null;
                break;
            case 'date' :
                this.dateFilter = value !== 'Select Payment Date' ? value : null;
                break;
            default:
                break;
        }
        this.applyPaymentFilter();
    }


    // Apply Payment above the types of filters
    applyPaymentFilter() {
        const paymentFilter = this.paymentStatusFilter ? this.paymentDetailsList.filter(status => status.paymentStatus === this.paymentStatusFilter) : this.paymentDetailsList;
        const typeFilter = this.paymentTypeFilter ? paymentFilter.filter(type => type.referenceType === this.paymentTypeFilter) : paymentFilter;
        this.paymentList = this.dateFilter
            ? typeFilter.filter(date => {
                const options: Intl.DateTimeFormatOptions = {day: '2-digit', month: '2-digit', year: 'numeric'};
                const formattedDate = new Date(date.createdAt).toLocaleDateString('en-GB', options);
                return formattedDate === this.dateFilter;
            })
            : typeFilter;
    }

    clearFilters() {
        this.paymentStatusFilter = 'Select Payment Status' && null;
        this.paymentTypeFilter = 'Select Payment Type' && null;
        this.dateFilter = 'Select Payment Date' && null;
        this.applyPaymentFilter();
    }

    getFormattedDate(createdAt: number): string {
        return this.datePipe.transform(createdAt, 'dd/MM/yyyy', 'IST', '');
    }

    isDuplicateDate(createdAt: number, index: number): boolean {
        // Check if the current date appears before (excluding) the current index
        return this.paymentList.slice(0, index).some(payment => payment.createdAt === createdAt);
    }*/

}